<template>
  <div class="container-fluid py-5 text-center">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-12 py-5">
            <b-icon-exclamation-circle font-scale="8" />
            <div class="w-100 py-4"></div>
            <h5>{{$t('pageNotFoundText')}}</h5>
            <div class="w-100 py-3"></div>
            <router-link to="/" class="btn btn-primary">
              {{$t('backToHome')}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>

</style>
